var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 py-1" },
    [
      _c(
        "b-dropdown",
        { attrs: { "toggle-class": "border-0 p-0 bg-none m-md-2 text-dark" } },
        [
          _c("template", { slot: "button-content" }, [
            _c(
              "span",
              _vm._l(_vm.norms, function (norm) {
                return _c("span", { key: norm.value }, [
                  _vm.checkedNorm === norm.value
                    ? _c("span", { staticClass: "mr-1" }, [
                        _vm._v(_vm._s(norm.text)),
                      ])
                    : _vm._e(),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.norms, function (norm) {
            return _c(
              "div",
              { key: norm.value },
              [
                norm.condition
                  ? _c(
                      "b-dropdown-item",
                      {
                        staticClass: "dropdown-item-web-header",
                        on: {
                          click: function ($event) {
                            return _vm.$bus.$emit(
                              "change-norm",
                              norm.value,
                              true
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            class:
                              _vm.checkedNorm === norm.value
                                ? "font-weight-bold text-green"
                                : "",
                          },
                          [_vm._v(_vm._s(norm.text))]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }